import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3ce26aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "old-recommendations" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "old-recommendations__title" }, "Рекомендации", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "old-recommendations__subtitle" }, " Процедуры для улучшения гигиены полости рта: ", -1))
const _hoisted_4 = { class: "old-recommendations__list" }
const _hoisted_5 = { class: "old-recommendations__list-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "old-recommendations__subtitle" }, "Консультация стоматолога:", -1))
const _hoisted_7 = { class: "old-recommendations__list" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "old-recommendations__subtitle" }, "Средства для домашней гигиены:", -1))
const _hoisted_9 = { class: "old-recommendations__list" }
const _hoisted_10 = { class: "old-recommendations__list-item" }
const _hoisted_11 = { class: "old-recommendations__list-item" }
const _hoisted_12 = { class: "old-recommendations__list-item" }

import { computed, PropType } from 'vue'
import { OldConsultationType } from '@/shared/types'
import {
  BRUSH_TYPE,
  CONSULTATIONS_MAP,
  HOME_TOOLS,
  TOOTHPASTE_TYPE,
} from '@/shared/constants'
import { declination } from '@/shared/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  consultation: Object as PropType<OldConsultationType>,
},
  setup(__props) {

const props = __props



const homeTools = computed(() => {
  return props.consultation.homeTools.filter(
    (tool) => !checkToolWithDescription(tool) ?? tool
  )
})

const signature = computed(() =>
  declination(props.consultation.reCleaning, ['месяц', 'месяца', 'месяцев'])
)

const checkToolWithDescription = (tool: number) => {
  return (
    (tool === 444 && props.consultation.brushType) ||
    (tool === 555 && props.consultation.toothPasteType.length)
  )
}

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", _hoisted_5, " Реминерализирующая терапия через " + _toDisplayString(__props.consultation.reCleaning) + " " + _toDisplayString(_unref(signature)), 1)
    ]),
    _createVNode(_component_el_divider, { class: "old-recommendations__divider" }),
    _hoisted_6,
    _createElementVNode("ul", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.consultation.consultations, (consultationItem, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "old-recommendations__list-item"
        }, _toDisplayString(_unref(CONSULTATIONS_MAP).get(consultationItem)), 1))
      }), 128))
    ]),
    _createVNode(_component_el_divider, { class: "old-recommendations__divider" }),
    _hoisted_8,
    _createElementVNode("ul", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeTools), (item) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_10, _toDisplayString(_unref(HOME_TOOLS).get(item)), 1))
      }), 256)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.consultation.brushType, (item) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(_unref(BRUSH_TYPE).get(item)), 1))
      }), 256)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.consultation.toothPasteType, (item) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_12, _toDisplayString(_unref(TOOTHPASTE_TYPE).get(item)), 1))
      }), 256))
    ])
  ]))
}
}

})